import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './Input.css';

const Input = React.forwardRef(({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  required = false,
  disabled = false,
  icon = null,
  size = 'default',
  className = '',
  ...props
}, ref) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  const handleFocus = (e) => {
    setIsFocused(true);
    // Seleccionar todo el texto al hacer focus
    if (e.target.select) {
      e.target.select();
    }
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const getSizeClass = () => {
    switch (size) {
      case 'xs': return 'input-xs';
      case 'sm': return 'input-small';
      case 'lg': return 'input-large';
      default: return '';
    }
  };

  const inputClasses = [
    'input-field',
    error && 'input-error',
    disabled && 'input-disabled',
    isFocused && 'input-focused',
    icon && 'input-with-icon',
    isPassword && 'input-with-password-toggle',
    className
  ].filter(Boolean).join(' ');

  const containerClasses = [
    'input-container',
    getSizeClass()
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {label && (
        <label className="input-label">
          {label}
          {required && <span className="input-required">*</span>}
        </label>
      )}

      <div className="input-wrapper">
        {icon && <div className="input-icon">{icon}</div>}

        <input
          ref={ref}
          type={inputType}
          className={inputClasses}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          required={required}
          {...props}
        />

        {isPassword && (
          <button
            type="button"
            className="password-toggle"
            onClick={togglePasswordVisibility}
            tabIndex={-1}
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        )}
      </div>

      {error && <div className="input-error-message">{error}</div>}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;